$(document).ready(function() {
  $('#owner_has_fiscal_address_true').on('click', function() {
    $('#fiscalForm').removeClass('d-none');
    $("#fiscalForm #owner_fiscal_address_attributes__destroy").val("0");
  });

  $('#owner_has_fiscal_address_false').on('click', function() {
    $('#fiscalForm').addClass('d-none');
    $("#fiscalForm input:not([type=hidden]), #fiscalForm select").val("");
    $("#fiscalForm #owner_fiscal_address_attributes__destroy").val("1");
  });
})
